export const enum ECrediteActions {
    SetIsShowDetails = '@credit/SetIsShowDetails',
    SetIsShowOptionSelect = '@credit/SetIsShowOptionSelect',
    SetSelectedCreditCondition = '@credit/SetSelectedCreditCondition',
}
